import authActionTypes from "../actions/authActionTypes";
let token = null;
try {
     token = JSON.parse(localStorage.getItem("token"))
}
catch (e) {
}

if (!token) {
    token = JSON.parse(sessionStorage.getItem("token"));
}

let lang = localStorage.getItem("lang");
if (!lang) {
  lang = "pl";
}

let userInfo = [];

try {
    userInfo = JSON.parse(localStorage.getItem("userInfo"));
}
catch(e){
    console.log(e);
    console.log("roles error");
}

const initialState = {
    token: token,
    lang: lang,
    userInfo: userInfo
};

const authReducer = function authReducer(state = initialState, action) {
    switch (action.type) {
        case authActionTypes.REFRESH_TOKEN_PENDING:
            return {
                ...state,
                isError: false,
                isPending: true
            };
        case authActionTypes.REFRESH_TOKEN_SUCCESS:
            return {
                ...state,
                token: action.data,
                isError: false,
                isPending: false
            };
        case authActionTypes.REFRESH_TOKEN_ERROR:
            return {
                ...state,
                token: null,
                isError: true,
                isPending: false
            };
        case authActionTypes.REFRESH_TOKEN_SET_USER_INFO:
            return {
                ...state,
                userInfo: action.data
            };
        case authActionTypes.CHANGE_LANGUAGE:
            return {
                ...state,
                lang: action.lang
            };
        default:
            return state;
    }
}

export {authReducer, initialState};